import {
  borderRadius,
  CheckBox,
  customScrollMinimal,
  Icon,
  TableCell,
  TableHeader,
  TanStackTableRoot,
  typographyV2,
} from '@toggle/design-system';
import styled, { createGlobalStyle, css, keyframes } from 'styled-components';

export const EntityDropdownPortalStyles = createGlobalStyle`
  .entity-watchlist-dropdown[class*="DropdownListContainer"] {
    z-index: calc(var(--z-index-modal) + 1) !important;
  }
`;

export const StyledTanStackTableRoot = styled(TanStackTableRoot)`
  table-layout: fixed;
  background-color: var(--background-soft);

  th {
    background-color: var(--background-soft);
  }

  th:first-child {
    width: 44px;
  }

  th:nth-child(2) {
    max-width: 116px;
  }

  tbody tr td:first-child {
    padding-left: 12px;
  }

  tbody tr:last-child td {
    border-bottom: none;
  }
`;

export const StyledTableHeader = styled(TableHeader)<{
  $error?: boolean;
  $isSmall: boolean;
}>`
  border-bottom: 1px solid var(--border-default);
  position: sticky;
  top: 0;
  left: 0;
  z-index: var(--z-index-header-cell);

  ${({ $isSmall }) =>
    $isSmall &&
    css`
      width: 132px;
    `}

  ${({ $error }) =>
    $error &&
    css`
      ${CheckBox.Styled.Checkmark} {
        border-color: var(--border-critical);
      }

      &:hover ${CheckBox.Styled.Checkmark} {
        border-color: var(--border-critical);
      }
    `}
`;

export const Text = styled.span<{ $color?: string }>`
  ${typographyV2.bodySm};

  ${({ $color }) =>
    $color &&
    css`
      color: ${$color};
    `}
`;

const slideDown = keyframes`
  0% {
    background-color: var(--surface-hover);
  }
  100% {
    background-color: inherit;
  }
`;

export const StyledTableCell = styled(TableCell)<{ $isNew?: boolean }>`
  text-align: initial;
  ${({ $isNew }) =>
    $isNew &&
    css`
      animation: ${slideDown} 1s ease-out;
    `}
`;

export const StyledFullRow = styled.tr`
  && {
    background-color: var(--surface-default);
    &:hover {
      background-color: var(--surface-default);
    }
  }
`;

export const StyledHeaderCell = styled(TableCell)`
  && {
    vertical-align: middle;
    padding-top: 8px;
    padding-bottom: 8px;
    border-bottom: none;
    background-color: inherit;
    &:hover {
      background-color: inherit;
      cursor: default;
    }
  }
`;

export const ShadowContainer = styled.div`
  position: relative;
  ${customScrollMinimal};
  overflow-y: auto;
  ${borderRadius.r3};

  &[data-shadow]::after {
    content: '';
    position: sticky;
    display: flex;
    bottom: 0;
    width: 100%;
    height: 45px;
    background: var(--background-gradient);
  }
`;

export const StyledIcon = styled(Icon)`
  cursor: default;
`;

export const HeaderCellLabel = styled.span`
  font-family: var(--font-nort);
  color: var(--text-soft);
  ${typographyV2.bodyXs};
`;
